import React from 'react';
import { useState, useEffect } from 'react';
import Card from './Card';
import '../css/cardlist.css';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import affiliateData from '../apis/affiliate-data';
import queryString from 'query-string';

//import { FETCH_AFFILIATE_DATA } from '../actions/types';

const CardList = (props) => {
  const [results, setResults] = useState([]);
  const [card, setCard] = useState([]);
  const [modal, setModal] = useState(false);
  const [programs, setPrograms] = useState([]);
  
  useEffect(() => {
    const queryStringValues = queryString.parse(props.location.search);

    const buildQuery = () => {
       let queryBuilder = '/api/affiliatesprograms?';
       for(const[key, value] of Object.entries(queryStringValues)) {
        queryBuilder += `${key}=${value}&`
       }
      const cleanQuery = queryBuilder.endsWith('&') ? queryBuilder.slice(0, -1) : queryBuilder;
      
      return cleanQuery
    }
    const query = buildQuery();
    
    const getAffiliates = async () => {
      const { data } = await affiliateData.get(query);
      try {
        const parsedData = JSON.parse(data);
        setResults(parsedData);
      } catch (e) {
        console.error(e);
      }
    }
    getAffiliates();
  }, []);

  const onCardSelect = (card) => {
    setCard(card);
    setPrograms(splitPrograms(card.programs));
    console.log('programs', programs);
    showModal();
  };

  const showModal = () => {
    console.log('card', card);
    setModal(true);
  };

  const hideModal = () => {
    setModal(false);
  };

  const splitPrograms = (programs) => {
    const str = programs.replace(/{|}/g, '');
    const arr = str.split(',');
    return arr;
  };

  // Create link for affiliate website
  const returnLink = (value) => {
    if (value && value !== 'N/A') {
      let hrefURL = value;
      if (hrefURL.indexOf('http') < 0) {
        hrefURL = `http://${value}`;
      }
      return hrefURL;
    }
    return value;
  };

  const renderPrograms = programs.map((program, index) => {
    return <li class="list-group-item border-0">{program}</li>;
  });

  const renderedResults = results.map((result, index) => {
    return (
      <React.Fragment key={index}>
        <Card
          name={result.Name}
          website={result.Website}
          imageUrl={result.s3logo}
          programs={result.Programs}
          autoGeneratedLogo={parseInt(result.auto_logo)}
          onCardSelect={onCardSelect}
        />
      </React.Fragment>
    );
  });

  return (
    <>
      <Modal show={modal} onHide={hideModal}>
        <Modal.Header>{card.name}</Modal.Header>
        <Modal.Body>
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <a href={returnLink(card.website)} target="_blank">
                  <img
                    src={card.imageUrl}
                    className="card-img-top"
                    alt="VOA logo"
                  />
                </a>
              </div>
              <div class="col-md-6">
                <ul class="list-group">{renderPrograms}</ul>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <a href={returnLink(card.website)} target="_blank">
            {card.website}
          </a>
        </Modal.Footer>
      </Modal>
      <div className="card-deck">{renderedResults}</div>
    </>
  );
};

export default CardList;
